import { localizeWithPath } from '../../../../nls.js';
import { Color } from '../../../../base/common/color.js';
import { registerColor, transparent } from '../colorUtils.js';
const _moduleId = "vs/platform/theme/common/colors/baseColors";
const foreground = registerColor('foreground', { dark: '#CCCCCC', light: '#616161', hcDark: '#FFFFFF', hcLight: '#292929' }, ( localizeWithPath(
 _moduleId,
 0,
 "Overall foreground color. This color is only used if not overridden by a component."
)));
const disabledForeground = registerColor('disabledForeground', { dark: '#CCCCCC80', light: '#61616180', hcDark: '#A5A5A5', hcLight: '#7F7F7F' }, ( localizeWithPath(
 _moduleId,
 1,
 "Overall foreground for disabled elements. This color is only used if not overridden by a component."
)));
const errorForeground = registerColor('errorForeground', { dark: '#F48771', light: '#A1260D', hcDark: '#F48771', hcLight: '#B5200D' }, ( localizeWithPath(
 _moduleId,
 2,
 "Overall foreground color for error messages. This color is only used if not overridden by a component."
)));
registerColor('descriptionForeground', { light: '#717171', dark: ( (transparent(foreground, 0.7))), hcDark: ( (transparent(foreground, 0.7))), hcLight: ( (transparent(foreground, 0.7))) }, ( localizeWithPath(
 _moduleId,
 3,
 "Foreground color for description text providing additional information, for example for a label."
)));
const iconForeground = registerColor('icon.foreground', { dark: '#C5C5C5', light: '#424242', hcDark: '#FFFFFF', hcLight: '#292929' }, ( localizeWithPath(_moduleId, 4, "The default color for icons in the workbench.")));
const focusBorder = registerColor('focusBorder', { dark: '#007FD4', light: '#0090F1', hcDark: '#F38518', hcLight: '#006BBD' }, ( localizeWithPath(
 _moduleId,
 5,
 "Overall border color for focused elements. This color is only used if not overridden by a component."
)));
const contrastBorder = registerColor('contrastBorder', { light: null, dark: null, hcDark: '#6FC3DF', hcLight: '#0F4A85' }, ( localizeWithPath(
 _moduleId,
 6,
 "An extra border around elements to separate them from others for greater contrast."
)));
const activeContrastBorder = registerColor('contrastActiveBorder', { light: null, dark: null, hcDark: focusBorder, hcLight: focusBorder }, ( localizeWithPath(
 _moduleId,
 7,
 "An extra border around active elements to separate them from others for greater contrast."
)));
const selectionBackground = registerColor('selection.background', { light: null, dark: null, hcDark: null, hcLight: null }, ( localizeWithPath(
 _moduleId,
 8,
 "The background color of text selections in the workbench (e.g. for input fields or text areas). Note that this does not apply to selections within the editor."
)));
const textLinkForeground = registerColor('textLink.foreground', { light: '#006AB1', dark: '#3794FF', hcDark: '#21A6FF', hcLight: '#0F4A85' }, ( localizeWithPath(_moduleId, 9, "Foreground color for links in text.")));
const textLinkActiveForeground = registerColor('textLink.activeForeground', { light: '#006AB1', dark: '#3794FF', hcDark: '#21A6FF', hcLight: '#0F4A85' }, ( localizeWithPath(
 _moduleId,
 10,
 "Foreground color for links in text when clicked on and on mouse hover."
)));
registerColor('textSeparator.foreground', { light: '#0000002e', dark: '#ffffff2e', hcDark: Color.black, hcLight: '#292929' }, ( localizeWithPath(_moduleId, 11, "Color for text separators.")));
registerColor('textPreformat.foreground', { light: '#A31515', dark: '#D7BA7D', hcDark: '#000000', hcLight: '#FFFFFF' }, ( localizeWithPath(_moduleId, 12, "Foreground color for preformatted text segments.")));
registerColor('textPreformat.background', { light: '#0000001A', dark: '#FFFFFF1A', hcDark: '#FFFFFF', hcLight: '#09345f' }, ( localizeWithPath(_moduleId, 13, "Background color for preformatted text segments.")));
const textBlockQuoteBackground = registerColor('textBlockQuote.background', { light: '#f2f2f2', dark: '#222222', hcDark: null, hcLight: '#F2F2F2' }, ( localizeWithPath(_moduleId, 14, "Background color for block quotes in text.")));
const textBlockQuoteBorder = registerColor('textBlockQuote.border', { light: '#007acc80', dark: '#007acc80', hcDark: Color.white, hcLight: '#292929' }, ( localizeWithPath(_moduleId, 15, "Border color for block quotes in text.")));
registerColor('textCodeBlock.background', { light: '#dcdcdc66', dark: '#0a0a0a66', hcDark: Color.black, hcLight: '#F2F2F2' }, ( localizeWithPath(_moduleId, 16, "Background color for code blocks in text.")));
export { activeContrastBorder, contrastBorder, disabledForeground, errorForeground, focusBorder, foreground, iconForeground, selectionBackground, textBlockQuoteBackground, textBlockQuoteBorder, textLinkActiveForeground, textLinkForeground };
